import { render } from "./App.vue?vue&type=template&id=562394d0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/disks/data-disk-1/saas-backend/prod/chatwidgetgit/mnv-chat-widget-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__